export const QUOTE_STATUS = {
  PENDING: 'Enviada',
  PARTIAL: 'Parcial',
  APPROVED: 'Aprobada por usuario',
  REJECTED: 'Rechazada por usuario',
} as const;
